import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/_auth/_side-layout/reports')({
  beforeLoad: () => {
    throw redirect({ to: '/funnels' as string });
  },
});
